var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowDownGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8274 1.26082C13.7801 1.14662 13.7 1.04901 13.5972 0.98033C13.4945 0.911655 13.3736 0.875 13.25 0.875H0.750003C0.626388 0.875 0.505549 0.911656 0.402767 0.980333C0.299985 1.04901 0.219877 1.14662 0.172573 1.26083C0.125269 1.37503 0.112893 1.5007 0.137012 1.62194C0.16113 1.74318 0.220659 1.85455 0.30807 1.94195L6.55807 8.19193C6.6161 8.24997 6.685 8.29601 6.76083 8.32742C6.83666 8.35883 6.91793 8.375 7 8.375C7.08208 8.375 7.16335 8.35883 7.23918 8.32742C7.315 8.29601 7.3839 8.24997 7.44194 8.19193L13.6919 1.94195C13.7793 1.85454 13.8389 1.74318 13.863 1.62194C13.8871 1.5007 13.8747 1.37503 13.8274 1.26082Z",
    fill: "#00C271"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownGreen);
export default __webpack_public_path__ + "static/media/ic-arrow-down-green.8ef91a4a.svg";
export { ForwardRef as ReactComponent };